import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { memo } from 'react';
import { useDropEventListContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { maxDaresReachedMessage } from 'root/src/shared/constants/dropEvent';
export const DropUserInfoWidget = memo(() => {
    const { dropEvent } = useDropEventListContext();
    if (!dropEvent.dropUserInfo) {
        return null;
    }
    const isMaxDaresReached = dropEvent.dropUserInfo.countOfAcceptedDares >= dropEvent.dropUserInfo.maxDares;
    const isAbleToParticipate = dropEvent.dropUserInfo.maxDares > 0;
    if (!isAbleToParticipate) {
        return <NotAbleToParticipate />;
    }
    if (isMaxDaresReached) {
        return <MaxDaresReached />;
    }
    return null;
});
function NotAbleToParticipate() {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				Need more Viewers to Participate
			</span>
		</div>);
}
function MaxDaresReached() {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				{maxDaresReachedMessage}
			</span>
		</div>);
}
